import axiosInstance from "../../../api/AxiosInstance";
import { endpoints } from "../../../services/endpoints";
import { getEventsCountRequest, getEventsCountRequestError, getEventsCountRequestSuccess } from "../../slices/event-management/GetEventsCountSlice";

export const GetEventsCountApi = () => async (dispatch) => {
    try {
        dispatch(getEventsCountRequest());
        axiosInstance({
            method: "GET",
            url: endpoints.eventsCount,
            headers: { "Content-Type": "application/json" },
        })
            .then((resp) => {
                return dispatch(getEventsCountRequestSuccess(resp?.data));
            })
            .catch((error) => {
                const _error = {
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                };
                return dispatch(getEventsCountRequestError(_error));
            });
    } catch (error) { }
};
